import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Monitor = createReactComponent("Monitor", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "3",
  width: "20",
  height: "14",
  rx: "2",
  ry: "2",
  key: "1krask"
}], ["line", {
  x1: "8",
  y1: "21",
  x2: "16",
  y2: "21",
  key: "10fzyn"
}], ["line", {
  x1: "12",
  y1: "17",
  x2: "12",
  y2: "21",
  key: "78hxbp"
}]]]);
export default Monitor;